let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Yk8m")).then(() => parcelRequire('3A2g0'));